/**
 * Session Timeout Warning Script for Waterfront Bar & Grill
 * Satisfies WCAG 2.2.1 (Timing Adjustable)
 */
(function() {
  const SESSION_DURATION = 20 * 60 * 1000; // 20 minutes
  const WARNING_THRESHOLD = 60 * 1000;    // Show warning 60 seconds before expiry
  
  let timeoutTimer;
  let warningTimer;
  let lastActivity = Date.now();

  function createModal() {
    if (document.getElementById('session-timeout-modal')) return;
    const modal = document.createElement('div');
    modal.id = 'session-timeout-modal';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-labelledby', 'timeout-title');
    modal.setAttribute('aria-modal', 'true');
    modal.style.cssText = 'position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,0.85);display:none;justify-content:center;align-items:center;z-index:2147483647;';

    modal.innerHTML = `
      <div style="background:#fff;padding:30px;border-radius:12px;max-width:450px;width:90%;text-align:center;box-shadow:0 10px 30px rgba(0,0,0,0.3);font-family:inherit;">
        <h2 id="timeout-title" style="margin-top:0;font-size:24px;color:#000;">Session Expiring Soon</h2>
        <p style="font-size:16px;color:#444;margin:20px 0;">
          For your security, your session will expire in <strong id="timeout-countdown">60</strong> seconds due to inactivity. 
          Would you like to stay on this page?
        </p>
        <div style="display:flex;gap:15px;justify-content:center;margin-top:25px;">
          <button id="extend-session-btn" style="background:#000;color:#fff;border:none;padding:12px 24px;border-radius:6px;cursor:pointer;font-weight:bold;font-size:16px;">Stay Logged In</button>
          <button id="logout-now-btn" style="background:transparent;color:#666;border:1px solid #ccc;padding:12px 24px;border-radius:6px;cursor:pointer;font-size:16px;">Refresh Now</button>
        </div>
      </div>
    `;
    document.body.appendChild(modal);
    document.getElementById('extend-session-btn').addEventListener('click', extendSession);
    document.getElementById('logout-now-btn').addEventListener('click', () => window.location.reload());
  }

  function resetTimers() {
    clearTimeout(timeoutTimer);
    clearTimeout(warningTimer);
    const modal = document.getElementById('session-timeout-modal');
    if (modal) modal.style.display = 'none';
    warningTimer = setTimeout(showWarning, SESSION_DURATION - WARNING_THRESHOLD);
    timeoutTimer = setTimeout(() => window.location.reload(), SESSION_DURATION);
  }

  function showWarning() {
    const modal = document.getElementById('session-timeout-modal');
    if (!modal) return;
    modal.style.display = 'flex';
    document.getElementById('extend-session-btn').focus();
    let timeLeft = WARNING_THRESHOLD / 1000;
    const countdownEl = document.getElementById('timeout-countdown');
    const interval = setInterval(() => {
      timeLeft--;
      if (countdownEl) countdownEl.textContent = timeLeft;
      if (timeLeft <= 0 || modal.style.display === 'none') clearInterval(interval);
    }, 1000);
  }

  function extendSession() {
    fetch('/cart.js').then(() => resetTimers()); // Keeps Shopify session alive
  }

  function handleActivity() {
    if (Date.now() - lastActivity > 30000) {
      lastActivity = Date.now();
      resetTimers();
    }
  }

  function init() {
    createModal();
    resetTimers();
    ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart'].forEach(e => {
      document.addEventListener(e, handleActivity, { passive: true });
    });
  }

  init();
})();